import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import {
  Create,
  Form,
  Input,
  TimePicker,
  Select,
  useForm,
  useSelect,
} from "@pankod/refine-antd";

import DatePicker from "components/atoms/datepicker.atom";
import dayjs from "dayjs";
import { useState } from "react";
import { IEvent } from "interfaces";

const { TextArea } = Input;

export const EventCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm<IEvent>();
  const { push } = useNavigation();

  const [isPrivate, setIsPrivate] = useState(false);

  const handleVisibilityChange = (value: string) => {
    setIsPrivate(value === "PRIVADO");
    if (value === "PRIVADO") {
      formProps.form?.setFieldsValue({
        name: "PRIVADO",
        description: undefined,
        attendant: undefined,
        attendant_exterior: undefined,
      });
    } else {
      formProps.form?.setFieldsValue({
        name: "",
      });
    }
  };

  const { selectProps: eventTypeSelectProps } = useSelect({
    resource: "event-types",
    optionLabel: "name",
    optionValue: "id",
  });

  const { selectProps: attendantSelectProps } = useSelect({
    resource: "attendants",
    optionLabel: "name",
    optionValue: "id",
  });

  const onFinish = async (values: any) => {
    const transformedValues = {
      ...values,
      start_time: dayjs(values.start_time).format("HH:mm"),
      end_time: dayjs(values.end_time).format("HH:mm"),
    };

    await formProps.onFinish?.(transformedValues);

    push("/events", {
      state: { defaultCalendarView: 'timeGridDay' },
    });
  };

  return (
    <Create title="Crear Evento" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          id_attendant: 5
        }}
        onFinish={onFinish}
      >
        <Form.Item
          label="Fecha del evento"
          name="event_date"
          rules={[{ required: true }]}
          initialValue={dayjs()}
        >
          <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
        </Form.Item>
        <Form.Item
          label="Hora de inicio del evento"
          name="start_time"
          rules={[{ required: true }]}
          initialValue={dayjs()}
        >
          <TimePicker style={{ width: "100%" }} format="HH:mm" />
        </Form.Item>
        <Form.Item
          label="Hora de fin del evento"
          name="end_time"
          rules={[
            { required: true },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || value.isAfter(getFieldValue("start_time"))) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("La hora de fin debe ser posterior a la hora de inicio")
                );
              },
            }),
          ]}
          initialValue={dayjs().add(1, "hour")}
        >
          <TimePicker style={{ width: "100%" }} format="HH:mm" />
        </Form.Item>
        <Form.Item
          label="Visibilidad del evento"
          name="visibility"
          rules={[{ required: true }]}
          initialValue="PUBLICO"
        >
          <Select
            options={[
              { label: "Público", value: "PUBLICO" },
              { label: "Privado", value: "PRIVADO" },
            ]}
            onChange={handleVisibilityChange}
          />
        </Form.Item>
        <Form.Item
          label="¿Asiste Prensa UAS?"
          name="press_visibility"
          rules={[{ required: true }]}
          initialValue="NO"
        >
          <Select
            options={[
              { label: "Sí", value: "SI" },
              { label: "No", value: "NO" },
            ]}
          />
        </Form.Item>
        <Form.Item
          label="Nombre del evento"
          name="name"
          rules={[{ required: true }]}
        >
          <Input disabled={isPrivate} />
        </Form.Item>
        <Form.Item
          label="Tipo de evento"
          name="id_event_type"
          rules={[{ required: false }]}
        >
          <Select {...eventTypeSelectProps} />
        </Form.Item>
        {!isPrivate && (
          <>
            <Form.Item
              label="Descripción"
              name="description"
              rules={[{ required: false }]}
            >
              <TextArea rows={4} />
            </Form.Item>
            <Form.Item
              label="¿Quién atiende?"
              name="id_attendant"
              rules={[{ required: false }]}
            >
              <Select {...attendantSelectProps} />
            </Form.Item>
            <Form.Item
              label="¿Quiénes asisten?"
              name="attendant_exterior"
              rules={[{ required: false }]}
            >
              <TextArea rows={4} /> 
            </Form.Item>
          </>
        )}
      </Form>
    </Create>
  );
};
